import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Text, TextStyles } from "@cinch-labs/design-system";
import { getDayMonthYearFormat } from "@cinch-labs/shared-util";
import cx from "classnames";
import Image from "next/legacy/image";
import styles from "./article-card.module.css";
export const ArticleCard = ({ title ="" , image , date ="" , featured =false  })=>{
    /*#__PURE__*/ return _jsxs("article", {
        className: cx(styles["root"], {
            [styles["topCard"]]: featured
        }),
        "data-featured": featured,
        "data-uid": title,
        children: [
            /*#__PURE__*/ _jsx("div", {
                className: cx(styles["imageContainer"], {
                    [styles["featured"]]: featured
                }),
                children: /*#__PURE__*/ _jsx(Image, {
                    className: styles["image"],
                    alt: (image === null || image === void 0 ? void 0 : image.alt) ?? "",
                    src: (image === null || image === void 0 ? void 0 : image.filename) || `${process.env["STAGE_NAME"] === "local" ? "" : process.env["STAGE_URL"]}/image-coming-soon.svg`,
                    layout: "responsive",
                    width: featured ? 400 : 250,
                    height: featured ? 253 : 158,
                    priority: featured
                })
            }),
            /*#__PURE__*/ _jsxs("div", {
                children: [
                    /*#__PURE__*/ _jsx(Text, {
                        type: featured ? TextStyles.vehicleTitle : TextStyles.mainTitle,
                        element: "h3",
                        className: styles["title"],
                        lineHeight: "display",
                        children: title
                    }),
                    /*#__PURE__*/ _jsx("time", {
                        dateTime: date,
                        className: styles["date"],
                        children: getDayMonthYearFormat(date)
                    })
                ]
            })
        ]
    });
};
